import {
  Backdrop,
  Box,
  Button,
  Fade,
  Grid,
  MenuItem,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";

const formatDateForInput = (dateStr) => {
  if (!dateStr) return "";
  const parsed = dayjs(dateStr, [
    "DD/MM/YYYY",
    "YYYY-MM-DD",
    "D/M/YYYY",
    dayjs.ISO_8601,
  ]);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
};

const EditUserModal = ({
  open,
  onClose,
  inputForm,
  handleInputChange,
  roleList,
  departmentList,
  designationList,
  jobGradeList,
  reportToList,
  onSubmit,
  mode,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Fade in={open} timeout={500}>
        <Box
          sx={{
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            width: { xs: "90%", sm: "80%", md: "70%" },
            maxHeight: "90vh",
            overflowY: "auto",
            px: { xs: 4 },
            py: { xs: 3 }
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" >
            <Typography variant="subtitle" sx={{ mb: 2, fontWeight: 600, textTransform: 'uppercase' }}>
              Edit User Information
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              {/* <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button> */}
              <Button
                fullWidth
                variant="contained"
                size="medium"
                sx={{
                  backgroundColor: "secondary.main",
                  fontWeight: "600",
                  "&:hover": { backgroundColor: "secondary.dark" }
                }}
                onClick={() => {
                  onSubmit('edit');
                  onClose();
                }}
              >
                Save
              </Button>
            </Stack>
          </Box>

          <Grid container spacing={2}>
            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography sx={{ fontWeight: 500, mb: 0.5 }}>{'Employee Code'}</Typography>
              <TextField
                fullWidth
                value={inputForm.code}
                disabled
                size="small"
                onChange={(e) => handleInputChange("code", e)}
              />
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography sx={{ fontWeight: 500, mb: 0.5 }}>{'Full Name'}</Typography>
              <TextField
                fullWidth
                value={inputForm.name}
                size="small"
                onChange={(e) => handleInputChange("name", e)}
              />
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography sx={{ fontWeight: 500, mb: 0.5 }}>{'Email'}</Typography>
              <TextField
                fullWidth
                value={inputForm.email}
                disabled
                size="small"
                onChange={(e) => handleInputChange("email", e)}
              />
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography sx={{ fontWeight: 500, mb: 0.5 }}>{'Role'}</Typography>
              <TextField
                select
                fullWidth
                value={inputForm.roleId}
                size="small"
                onChange={(e) => handleInputChange("roleId", e)}
              >
                {roleList.map((role) => (
                  <MenuItem key={role.roleId} value={role.roleId}>
                    {role.roleName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography sx={{ fontWeight: 500, mb: 0.5 }}>{'Gender'}</Typography>
              <TextField
                select
                fullWidth
                value={(inputForm.gender || '').toLowerCase()}
                size="small"
                onChange={(e) => handleInputChange("gender", e)}
              >
                <MenuItem value="male">Male</MenuItem>
                <MenuItem value="female">Female</MenuItem>
              </TextField>
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography sx={{ fontWeight: 500, mb: 0.5 }}>{'Date of Birth'}</Typography>
              <TextField
                fullWidth
                type="date"
                value={formatDateForInput(inputForm.dob)}
                size="small"
                onChange={(e) => handleInputChange("dob", e)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography sx={{ fontWeight: 500, mb: 0.5 }}>{'Department'}</Typography>
              <TextField
                select
                fullWidth
                value={inputForm.departmentId}
                size="small"
                onChange={(e) => handleInputChange("departmentId", e)}
              >
                {departmentList.map((dept) => (
                  <MenuItem key={dept.departmentId} value={dept.departmentId}>
                    {dept.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography sx={{ fontWeight: 500, mb: 0.5 }}>{'Designation'}</Typography>
              <TextField
                select
                fullWidth
                value={inputForm.designationId}
                size="small"
                onChange={(e) => handleInputChange("designationId", e)}
              >
                {designationList.map((desig) => (
                  <MenuItem key={desig.designationId} value={desig.designationId}>
                    {desig.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography sx={{ fontWeight: 500, mb: 0.5 }}>{'Job Grade'}</Typography>
              <TextField
                select
                fullWidth
                value={inputForm.jobGradeId}
                size="small"
                onChange={(e) => handleInputChange("jobGradeId", e)}
              >
                {jobGradeList.map((job) => (
                  <MenuItem key={job.jobGradeId} value={job.jobGradeId}>
                    {job.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography sx={{ fontWeight: 500, mb: 0.5 }}>{'Report To'}</Typography>
              <TextField
                select
                fullWidth
                value={inputForm.reportsToId}
                size="small"
                onChange={(e) => handleInputChange("reportsToId", e)}
              >
                {reportToList.map((reportToId) => (
                  <MenuItem key={reportToId.employeeId} value={reportToId.employeeId}>
                    {reportToId.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

export default EditUserModal;
